<div class="container">
    <div class="student-container">
        <div class="student-filter">
            <div class="header">
                <h1>
                    Seleção de Alunos
                </h1>
            </div>
            <div class="filters" *ngFor="let filter of filters; let indexFilter = index">
                <div class="row-filter" [ngClass]="{ turma: filter.title === 'Turma' && !showClearAllBtn }"
                    *ngIf="filter.show">
                    <div class="title">
                        <small></small>

                        <small *ngIf="filter.selected">
                            {{ filter.title }}
                        </small>

                        <small class="not-selected" *ngIf="!filter.selected">
                            {{ filter.notSelectedText }}
                        </small>
                        <a class="invisible_anchor" *ngIf="!filter.selected">a</a>
                        <a *ngIf="filter.selected" (click)="clearFilter(indexFilter)" class="example-button-row">
                            <i class="fas fa-edit"></i>
                        </a>
                    </div>
                    <ng-container *ngIf="filter.selected">
                        <div id="selected-filter">
                            <div style="margin-bottom: 30px; font-weight: bold;">
                                <div>
                                    {{ filter.label }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!filter.selected">
                        <div class="card-list" *ngFor="let item of filter.items; let indexItem = index">
                            <mat-card (click)="selectItem(item.id, indexFilter)" [ngClass]="{ active: item.active }">
                                {{ item.nome }}</mat-card>
                        </div>
                    </ng-container>

                    <hr *ngIf="filter.selected" [ngClass]="{ last: filter.title === 'Turma' }" />
                </div>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 10px;">
                <app-loader></app-loader>
            </div>

            <div class="slider">
                <span *ngFor="let num of numOfFilter; let numIndex = index"><i class="fas fa-circle" [ngClass]="{
                            active: num
                        }"></i></span>
            </div>

            <div *ngIf="showClearAllBtn" class="button-container">
                <app-button (click)="clearAllFilters()">
                    <i class="fas fa-search"></i>
                    Nova busca
                </app-button>
            </div>
        </div>

        <hr class="side-separator" />

        <div class="card-container" *ngIf="alunos.length > 0 && !error">
            <!-- <div class="title-container">
                <h3>
                    <span class="title">
                        Lista de Alunos
                    </span>
                </h3>
            </div> -->
            <header class="title-container">
                <!-- <button (click)="global()">Alterar tema</button> -->
                <span class="title">Lista de alunos</span>
                <hr class="wide-separator" />
            </header>

            <div class="cards">
                <div (click)="selectStudent(aluno.tokenAcesso)" class="card-flex" *ngFor="let aluno of alunos">
                    <div>
                        <img [src]="alunoService.getImg(aluno.nomeArquivoFoto, 'baixa')" alt="imagem aluno"
                            onerror="this.src = 'assets/images/default.png'" />
                    </div>
                    <div class="card-student-name">
                        <span>
                            {{ aluno.nome }}
                        </span>
                        <span *ngIf="!aluno.avaliado">
                            Não avaliou
                        </span>
                        <span *ngIf="aluno.avaliado" style="color: #00aa00;">Avaliou</span>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="error" class="error-container">
            <div *ngIf="error?.code === 'token_invalido_acesso_aluno'">
                <div id="error-message">
                    <i class="fal fa-user-slash"></i>
                    <strong>Desculpe!</strong>
                    <span>{{ error.message }}</span>
                </div>
            </div>

            <div *ngIf="error?.code === 'token_fora_vigencia_acesso_aluno'">
                <div id="error-message">
                    <i class="far fa-calendar-times"></i>
                    <strong>Lamento!</strong>
                    <span>{{ error.message }}</span>
                </div>
            </div>
        </div>

        <!--  -->

        <!-- <button (click)="changeTheme()">DALTONICO</button> -->
        <!-- <div class="error-container" *ngIf="alunos.length === 0">
            <div>
                <div id="error-message">
                    <i class="fa fa-user-slash"></i>
                    <strong>Desculpe!</strong>
                    <span>Infelizmente o aluno não pode ser encontrado.</span>
                </div>
            </div>
        </div> -->
    </div>
</div>